<template>
    <div :class="`metric-summary-item --${ this.className }`">
        <span v-if="isSapMetric"
              class="metric-summary-item__sap-score">SAP {{ sapRating }}</span>
        <i v-else
           :class="`metric-summary-item__icon fas fa-${ this.metric.icon }`" />
        <span v-if="isSapMetric"
              class="metric-summary-item__sap-change">({{ sapChange }})</span>
        <span v-else-if="hasWorsened"
              class="metric-summary-item__warning"><i class="fas fa-exclamation-triangle metric-summary-item__warning__icon" /><span class="metric-summary-item__warning__note"> - </span></span>
        <span v-else
              class="metric-summary-item__percentage">{{ percentageSaving }}</span>
    </div>
</template>

<script>

import MetricDisplay from '@/components/metric-display'

export default {

    mixins: [
        MetricDisplay,
    ],
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_metric-summary-item.scss

.metric-summary-item {
    font-size: 0.8rem;
    line-height: 0.7rem;

    @include bp-min-small {
        font-size: 1.3rem;
        line-height: 1.3rem;
    }

    @include element('warning') {

        @include element('icon') {
            display: none;

            @include bp-min-small {
                display: inline-block;
            }
        }

        @include element('note') {
            padding-right: rem(10px);
            font-weight: bold;

            @include bp-min-small {
                display: none;
            }
        }
    }

    @include elements('percentage' 'sap-change' 'warning') {
        display: inline-block;
        font-size: 0.9rem;
        padding-left: 0.15rem;
        min-width: 2.4rem;

        @include bp-min-small {
            vertical-align: top;
            position: relative;
            top: -0.3rem;
            min-width: auto;
        }
    }

    @include element('sap-score') {
        font-weight: bold;
        display: block;
        padding-bottom: 0.25rem;

        @include bp-min-small {
            display: inline;
            padding-bottom: 0;
        }
    }
}

</style>
